/* React Higher Order Component which fetches project data where project.user_id = props.channelId
    Child (InnerComponent) will only render once channel data is successfully fetched.
    child will receive props: {
        channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        projectStoreState: PropTypes.shape({ initialized: PropTypes.bool, projects: PropTypes.array, ... }),
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const has = require('lodash/has');
const uuid = require('uuid');

const ChannelActions = require('../../actions/ChannelActions');
const ProjectActions = require('../../actions/ProjectActions');
const ProjectStore = require('../../stores/ProjectStore');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    forceRefreshOnMount: PropTypes.bool, // force refresh of channel data, even if channel store is already initialized
    hideLoadingIcon: PropTypes.bool
};

const defaultProps = {
    forceRefreshOnMount: false,
    hideLoadingIcon: false
};

export default function withChannelProjects(WrappedComponent) {
    class WithChannelProjects extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                projectStoreState: ProjectStore.getStateChannel(props.channelId),
                getActionId: null,
                fatalError: null
            }

            this.unsubscribes = [ProjectStore.listen(this.onProjectStoreChange.bind(this))];
        }

        componentDidMount() {
            if (!this.state.projectStoreState.initialized || this.props.forceRefreshOnMount) {
                const actionId = uuid.v4();
                this.setState({ getActionId: actionId }, () => {
                    ProjectActions.getAllProjects(actionId);
                });
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        onProjectStoreChange(newState) {
            let additionalState = {};

            if (newState.action.id === this.state.getActionId) {
                additionalState = { ...additionalState, getActionId: null };

                if (!!newState.action.error) {
                    additionalState = { ...additionalState, fatalError: newState.action.error };
                }

            }

            this.setState({
                projectStoreState: ProjectStore.getStateChannel(this.props.channelId),
                ...additionalState
            });
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} />;
            }

            if (!this.state.projectStoreState.initialized) {
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    projectStoreState={this.state.projectStoreState}
                />
            );
        }
    }

    WithChannelProjects.propTypes = propTypes;
    WithChannelProjects.defaultProps = defaultProps;
    WithChannelProjects.displayName = `WithChannelProjects(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithChannelProjects;
}
